import { render, staticRenderFns } from "./AdminCmsCredentialsTab.vue?vue&type=template&id=634993d5&scoped=true&"
import script from "./AdminCmsCredentialsTab.vue?vue&type=script&lang=ts&"
export * from "./AdminCmsCredentialsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634993d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
